import {
    PrivateLayoutFooter,
    PrivateLayoutHeader,
    PrivateLayoutSidebar,
} from 'common/Components/PrivateLayout';

import { PrivateLayoutProps } from './types';

import styles from './PrivateLayout.module.scss';

const PrivateLayout = ({ children, menu }: PrivateLayoutProps) => {
    return (
        <main className={styles.container}>
            <PrivateLayoutSidebar menu={menu} />
            <section id="private-layout" className={styles.content_wrapper}>
                <PrivateLayoutHeader />
                <div className={styles.content}>{children}</div>
                <PrivateLayoutFooter />
            </section>
        </main>
    );
};

export default PrivateLayout;
